import { render } from "./LinksMenu.vue?vue&type=template&id=26dc2889&scoped=true&ts=true"
import script from "./LinksMenu.vue?vue&type=script&lang=ts"
export * from "./LinksMenu.vue?vue&type=script&lang=ts"

import "./LinksMenu.vue?vue&type=style&index=0&id=26dc2889&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26dc2889"]])

export default __exports__